export default __webpack_public_path__ + "static/swintergerst-9cd3494643d0bfe9ec96183b2d8bfd73.png";